import type { FC, ReactNode } from "react";
import type { ValidatedWorkspaceGlobals } from "../index";
import { CurrentWorkspaceGlobalsContext } from "./context";

type CurrentWorkspaceGlobalsProviderProps = {
  globals: ValidatedWorkspaceGlobals;
  children: ReactNode;
};
// currentWorkspace の設定を提供する
// WorkspaceGlobalsGuard で挿入される
export const CurrentWorkspaceGlobalsProvider: FC<
  CurrentWorkspaceGlobalsProviderProps
> = ({ globals, children }) => {
  return (
    <CurrentWorkspaceGlobalsContext.Provider value={{ globals }}>
      {children}
    </CurrentWorkspaceGlobalsContext.Provider>
  );
};
